/**
 * Les sons du live de l'élève, ceux de l'ancien : le passage en Concentré et en Dialogue (`LKEvents`),
 * l'activité poussée (`ActivityWrapperScreen`), un message (`useLiveKitEventListener`), l'activité
 * rendue par le tuteur, l'appel à l'attention du remplacement (`tutorNoShow/`), et le mode autonome :
 * Sam qui demande comment ça s'est passé (`AutoEvalOverlay`), les propositions arrivées
 * (`AutoModeChoiceModal`), l'activité lancée ou relancée (`AutoModeChoiceModal`, `useAutoModeReplaySame`).
 */
import { type AutoModeCue } from "../../../../../../engine/live/student/autoMode"
import { type StudentLiveSound } from "../../../../../../engine/live/student/useStudentLive"
import { SAM_SOUNDS } from "../studentSounds"

/** Un son que l'écran du live joue : ceux du live, et ceux du mode autonome. */
export type LiveScreenSound = StudentLiveSound | AutoModeCue

/* eslint-disable @typescript-eslint/no-require-imports */
export const LIVE_SOUNDS: Record<LiveScreenSound, number> = {
    focused: require("../../../../../../../assets/sounds/minimize_001_low.mp3") as number,
    dialogue: require("../../../../../../../assets/sounds/maximize_001_low.mp3") as number,
    new_activity: require("../../../../../../../assets/sounds/falling.mp3") as number,
    new_message: require("../../../../../../../assets/sounds/toggle_001.mp3") as number,
    activity_validated: require("../../../../../../../assets/sounds/finished.mp3") as number,
    attention: require("../../../../../../../assets/sounds/question_002.mp3") as number,
    auto_mode_opened: SAM_SOUNDS.open,
    auto_mode_proposals: require("../../../../../../../assets/sounds/confirmation_002.mp3") as number,
    auto_mode_started: require("../../../../../../../assets/sounds/falling.mp3") as number,
}
/* eslint-enable @typescript-eslint/no-require-imports */
